import { render, staticRenderFns } from "./compareInfo.vue?vue&type=template&id=3cb8e343&scoped=true&"
import script from "./compareInfo.vue?vue&type=script&lang=js&"
export * from "./compareInfo.vue?vue&type=script&lang=js&"
import style0 from "./compareInfo.vue?vue&type=style&index=0&id=3cb8e343&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8e343",
  null
  
)

export default component.exports